function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import EmailTemplateDestroyLink from '@engine/components/containers/email-templates/destroy-link';
import EmailTemplateOpenFormLink from '@engine/components/presentational/email-templates/open-form-link';
import React from 'react';
import { connect } from 'react-redux';

var EmailTemplateRows = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailTemplateRows, _React$Component);

  var _super = _createSuper(EmailTemplateRows);

  function EmailTemplateRows() {
    _classCallCheck(this, EmailTemplateRows);

    return _super.apply(this, arguments);
  }

  _createClass(EmailTemplateRows, [{
    key: "render",
    value: function render() {
      var _this = this;

      /*
       * Initialize and filter the templates here (not in the MapStateToProps)
       * in order to avoid the re-rendering
       */
      var emailTemplates = Object.values(this.props.emailTemplates).filter(function (template) {
        return _this.props.emailTemplateIds.includes(template.id);
      });
      return React.createElement(React.Fragment, null, emailTemplates.map(function (template, index) {
        return React.createElement("tr", {
          key: template.id
        }, _this.injectSpace(index, emailTemplates.length), React.createElement("td", null, "".concat(I18n.t('object.attributes.language'), ": ").concat(template.language), template["default"] && React.createElement("span", {
          className: "label label-success ml-5"
        }, "default")), React.createElement("td", null, React.createElement(EmailTemplateOpenFormLink, {
          template: template,
          linkText: I18n.t('actions.default.edit'),
          configurationType: _this.props.configurationType,
          url: _this.templateUrl(template.id)
        }), React.createElement("span", {
          className: "separator-vertical"
        }), React.createElement(EmailTemplateDestroyLink, {
          url: _this.templateUrl(template.id),
          templateId: String(template.id),
          configurationId: String(template.email_configuration_id)
        })));
      }));
    }
  }, {
    key: "templateUrl",
    value: function templateUrl(id) {
      return this.props.baseUrl.concat("/email_templates/".concat(id));
    }
    /*
     * Inject td in the row when the templates
     * are loaded within the EC index page
     */

  }, {
    key: "injectSpace",
    value: function injectSpace(index, rowSpanLength) {
      if (index === 0 && this.props.loadedWithinConfigurations) {
        return React.createElement("td", {
          colSpan: "4",
          rowSpan: rowSpanLength
        });
      }
    }
  }]);

  return EmailTemplateRows;
}(React.Component);

EmailTemplateRows.defaultProps = {
  loadedWithinConfigurations: false
};
export default connect(function (state) {
  return {
    emailTemplates: state.entities.templates
  };
}, {})(EmailTemplateRows);